import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  apiUrl = environment.apiUrl
  constructor(private http:HttpClient) { }

  getHomePageData(){
    let lat = localStorage.getItem('lat')
    let lng = localStorage.getItem('lng')
    let params= {}
    if (lat=='undefined' || !lat){

    }
    else{
      params["lat"] = lat
    }
    if (lng=='undefined' || !lng){
    }
    else{
      params["lng"] = lng
    }
      
    const httpOptions = {

      params: params
  };


    return this.http.get(`${this.apiUrl}/User/home`,httpOptions)
  }
  getArticles(type){
    let params={}
    params["type"] = type
    const httpOptions = {

      params: params
  };
    return this.http.get(`${this.apiUrl}/User/listBlogs`,httpOptions)
  }
  getAllBlogs(){
   
    return this.http.get(`${this.apiUrl}/User/listBlogs`)
  }
  getCities(type){
    return this.http.get(`${this.apiUrl}/User/listCities?type=${type}`)
  }


  public getPosition(): Observable<GeolocationPosition> {
    return Observable.create(
      (observer: any) => {
        navigator.geolocation.watchPosition((pos: GeolocationPosition) => {
          observer.next(pos);
        }),
          () => {
            console.log('Position is not available');
          },
          {
            enableHighAccuracy: true
          };
      });
  }
  getBanners(){
    return this.http.get(`${this.apiUrl}/User/list_banners`)
  }


}
